import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useSelector } from 'react-redux';
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Chip,
  IconButton,
  Tooltip,
  Typography,
  Grid,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  FormGroup,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import { Visibility, CheckCircle, Cancel, Block, GetApp } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import HttpService from '../services/httpService';
import EmailIcon from '@material-ui/icons/Email';
const useStyles = makeStyles((theme) => ({
  root: {
    padding: '24px',
    width: '100%',
  },
  table: {
    minWidth: 650,
  },
  headerCell: {
    backgroundColor: '#1C375D',
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
    border: '1px solid #fff',
  },
  tableCell: {
    textAlign: 'center',
    border: '1px solid #e0e0e0',
  },
  statusChip: {
    fontWeight: 'bold',
    minWidth: '80px',
  },
  statusOpen: {
    backgroundColor: '#ff9800',
    color: 'white',
  },
  statusResolved: {
    backgroundColor: '#4caf50',
    color: 'white',
  },
  statusClosed: {
    backgroundColor: '#f44336',
    color: 'white',
  },
  actionButton: {
    margin: '0 4px',
  },
  dialogContent: {
    minWidth: '500px',
    padding: '16px',
  },
  infoRow: {
    marginBottom: '16px',
    padding: '8px',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
  },
  infoLabel: {
    fontWeight: 'bold',
    display: 'inline-block',
    width: '150px',
  },
  infoValue: {
    display: 'inline-block',
  },
  statCard: {
    height: '100%',
    textAlign: 'center',
  },
  statNumber: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: '#1C375D',
  },
  statLabel: {
    fontSize: '1rem',
    color: '#666',
    marginTop: '8px',
  },
  dashboardGrid: {
    marginBottom: '24px',
  },
}));

const FlaggedProject = ({ setLoading, setSnackInfo }) => {
  const classes = useStyles();
  const { userDetails } = useSelector(state => state.user);
  
  const [selectedProject, setSelectedProject] = useState(null);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [statusFormData, setStatusFormData] = useState({
    status: '',
    resolutionRemarks: '',
    closingRemarks: '',
    rejectionRemarks: '',
    attachments: []
  });
  const [users, setUsers] = useState([]);
  const [discrepancies, setDiscrepancies] = useState([]);
  const [experienceCenters, setExperienceCenters] = useState([]);
  const [filters, setFilters] = useState({
    discrepancyId: '',
    experienceCenterId: '',
    raisedBy: '',
    status: '',
    startDate: '',
    endDate: ''
  });
  const [dashboardData, setDashboardData] = useState({
    stats: [],
    recentFlags: [],
    byExperienceCenter: []
  });
  const [flagsLoading, setFlagsLoading] = useState(true);

  useEffect(() => {
    fetchUsers();
    fetchDiscrepancies();
    fetchExperienceCenters();
    if (userDetails._id) {
      fetchDashboard();
    }
  }, [userDetails]);

  const fetchExperienceCenters = async () => {
    try {
      const response = await HttpService.getExpericenCenters();
      setExperienceCenters(response.data || []);
    } catch (error) {
      console.error('Error fetching experience centers:', error);
    }
  };

  const fetchDashboard = async (filterValues = null) => {
    if (!userDetails._id) {
      return;
    }
    
    setLoading(true);
    setFlagsLoading(true);
    try {
      const params = {
        userId: userDetails._id
      };

      // Use provided filters or current state filters
      const activeFilters = filterValues !== null ? filterValues : filters;

      // Add filters if they are set
      if (activeFilters.discrepancyId) {
        params.discrepancyId = activeFilters.discrepancyId;
      }
      if (activeFilters.experienceCenterId) {
        params.experienceCenterId = activeFilters.experienceCenterId;
      }
      if (activeFilters.raisedBy && activeFilters.raisedBy.trim()) {
        params.raisedBy = activeFilters.raisedBy.trim();
      }
      if (activeFilters.status) {
        params.status = activeFilters.status;
      }
      if (activeFilters.startDate) {
        params.startDate = activeFilters.startDate;
      }
      if (activeFilters.endDate) {
        params.endDate = activeFilters.endDate;
      }
      if(userDetails?.email==="admin@naraci.com" || userDetails?.email==="shomil@decorpot.com" || userDetails?.email==="naren.pradhan@decorpot.com" || userDetails?.email==="dk@decorpot.com" ||   userDetails?.roles?.some(role => role.name === "Data Analyst") ){
        params.isSpecialUser = true
      }
      else{
        params.isSpecialUser = false
      }


      const response = await HttpService.getFlaggedDashboard(params);      
      if (response.data && response.data.success) {
        // New response structure: data is an array of flagged projects
        const flaggedProjects = Array.isArray(response.data.data) 
          ? response.data.data 
          : [];
        
        setDashboardData({
          stats: [],
          recentFlags: flaggedProjects,
          byExperienceCenter: []
        });
      }
    } catch (error) {
      setSnackInfo(error?.response?.data?.message || 'Failed to fetch dashboard data', 'error');
    }
    setLoading(false);
    setFlagsLoading(false);
  };

  const fetchUsers = async () => {
    try {
      const response = await HttpService.getAllUsers();
      setUsers(response.data || []);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const fetchDiscrepancies = async () => {
    try {
      const response = await HttpService.getAllDiscrepanciesList();
      setDiscrepancies(response.data || []);
    } catch (error) {
      console.error('Error fetching discrepancies:', error);
    }
  };

  const handleViewDetails = async (project) => {
    setSelectedProject(project);
    setViewDialogOpen(true);
  };

  const canUserResolve = (project) => {
    const userId = userDetails._id;
    // flagTo can resolve when status is Open
    const isFlagTo = project.flagTo && (
      (typeof project.flagTo === 'object' && project.flagTo._id === userId) ||
      project.flagTo === userId
    );

    return isFlagTo && project.status === 'Open';
  };

  const canUserClose = (project) => {
    const userId = userDetails._id;
    // Only raiser can close flags
    const isRaiser = project.raisedBy && (
      (typeof project.raisedBy === 'object' && project.raisedBy._id === userId) ||
      project.raisedBy === userId
    );
    
    return isRaiser && project.status === 'Resolved';
  };

  const canUserReject = (project) => {
    const userId = userDetails._id;
    // Only raiser can reject flags
    const isRaiser = project.raisedBy && (
      (typeof project.raisedBy === 'object' && project.raisedBy._id === userId) ||
      project.raisedBy === userId
    );
    
    // Raiser can reject when status is Open or Resolved
    return isRaiser && (project.status === 'Open' || project.status === 'Resolved');
  };
  const canMailSend = (project) => {
    const userId = userDetails._id;

    const isFlagTo =
      project.flagTo &&
      ((typeof project.flagTo === "object" && project.flagTo._id === userId) ||
        project.flagTo === userId);

    const isResolved = project.status === "Resolved";

    return isResolved && isFlagTo;
  };
  const handleSendfollowupmail = async (project) => {
    if (!project) return;

    setLoading(true);
    try {
      const payload = {
        leadId: getLeadId(project),
        raisedBy: project.raisedBy,
        DiscrepancyDescription: project.description,
        ResolutionSummary:project.resolutionRemarks
      };

      const response = await HttpService.Sendfollowupmail(payload);

      if (response.data && response.data.success) {
        setSnackInfo("follow-up email sent successfully!", "success");
      } else {
        setSnackInfo(
          response.data?.message || "Failed to send follow-up email.",
          "error"
        );
      }
    } catch (error) {
      setSnackInfo(
        error.response?.data?.message || "Error sending follow-up email",
        "error"
      );
    }
    setLoading(false);
  };
  
  const handleStatusAction = (project, status) => {
    setSelectedProject(project);
    setStatusFormData({
      status: status,
      resolutionRemarks: '',
      closingRemarks: '',
      rejectionRemarks: '',
      attachments: []
    });
    setStatusDialogOpen(true);
  };

  const handleAttachmentChange = async (event) => {
    if (!event.target.files || event.target.files.length === 0) return;
    
    setLoading(true);
    try {
      const files = Array.from(event.target.files);
      const uploadedUrls = [];
      
      for (const file of files) {
        const fd = new FormData();
        fd.append("file", file);
        const fileUploadRes = await HttpService.uploadFile(fd);
        // Assuming the response has the URL in fileUploadRes.data or fileUploadRes.data.url
        const url = fileUploadRes.data?.url || fileUploadRes.data || fileUploadRes.data?.data;
        if (url) {
          uploadedUrls.push({
            url: url,
            name: file.name
          });
        }
      }
      
      setStatusFormData(prev => ({
        ...prev,
        attachments: [...prev.attachments, ...uploadedUrls]
      }));
    } catch (error) {
      setSnackInfo("Failed to upload attachment", "error");
      console.error('Error uploading file:', error);
    }
    setLoading(false);
  };

  const removeAttachment = (index) => {
    setStatusFormData(prev => ({
      ...prev,
      attachments: prev.attachments.filter((_, i) => i !== index)
    }));
  };

  const handleStatusUpdate = async () => {
    if (!selectedProject) return;

    // Map status to action
    const actionMap = {
      'Resolved': 'resolve',
      'Rejected': 'reject',
      'Closed': 'close'
    };

    const action = actionMap[statusFormData.status];
    if (!action) {
      setSnackInfo('Invalid action', 'error');
      return;
    }

    // Get the appropriate remarks based on action
    let description = '';
    if (statusFormData.status === 'Resolved') {
      if (!statusFormData.resolutionRemarks.trim()) {
        setSnackInfo('Resolution Remarks is required', 'error');
        return;
      }
      description = statusFormData.resolutionRemarks;
    } else if (statusFormData.status === 'Closed') {
      if (!statusFormData.closingRemarks.trim()) {
        setSnackInfo('Closing Remarks is required', 'error');
        return;
      }
      description = statusFormData.closingRemarks;
    } else if (statusFormData.status === 'Rejected') {
      if (!statusFormData.rejectionRemarks.trim()) {
        setSnackInfo('Rejection Remarks is required', 'error');
        return;
      }
      description = statusFormData.rejectionRemarks;
    }

    try {
      // Extract URLs from attachments array
      const attachmentUrls = statusFormData.attachments.map(att => 
        typeof att === 'string' ? att : att.url || att
      );

      const actionPayload = {
        action: action,
        userId: userDetails?._id,
        description: description,
        attachmentUrls: attachmentUrls.length > 0 ? attachmentUrls : undefined
      };

      await HttpService.updateFlaggedProjectAction(selectedProject._id, actionPayload);

      // If current view is filtered, auto-switch filter to the new status so the item stays visible
      if (filters.status === 'Open' && statusFormData.status === 'Resolved') {
        const nextFilters = { ...filters, status: 'Resolved' };
        setFilters(nextFilters);
        await fetchDashboard(nextFilters);
      } else if (filters.status === 'Resolved' && statusFormData.status === 'Closed') {
        const nextFilters = { ...filters, status: 'Closed' };
        setFilters(nextFilters);
        await fetchDashboard(nextFilters);
      } else if ((filters.status === 'Open' || filters.status === 'Resolved') && statusFormData.status === 'Rejected') {
        const nextFilters = { ...filters, status: 'Rejected' };
        setFilters(nextFilters);
        await fetchDashboard(nextFilters);
      } else {
        // Ensure dashboard refresh completes before closing dialog/snackbar
        const emptyFilters = {
          discrepancyId: '',
          experienceCenterId: '',
          raisedBy: '',
          status: '',
          startDate: '',
          endDate: ''
        };
        // Reset filters state
        setFilters(emptyFilters);
        // Immediately fetch dashboard with empty filters (no filters applied)
        // This will reset the view to show all data based on user's permissions
        if (userDetails._id) {
          fetchDashboard(emptyFilters);
        }
      }
      setStatusDialogOpen(false);
      setSnackInfo(`Flag ${statusFormData.status.toLowerCase()} successfully`, 'success');
    } catch (error) {
      setSnackInfo(error?.response?.data?.message || 'Failed to update status', 'error');
      console.error('Error updating status:', error);
    }
  };

  const getStatusChip = (status) => {
    const statusClass = 
      status === 'Open' ? classes.statusOpen :
      status === 'Resolved' ? classes.statusResolved :
      status === 'Rejected' ? classes.statusClosed :
      classes.statusClosed;

    return (
      <Chip 
        label={status} 
        className={`${classes.statusChip} ${statusClass}`}
        size="small"
      />
    );
  };

  const getDiscrepancyName = (discrepancyId) => {
    // Handle populated object
    if (typeof discrepancyId === 'object' && discrepancyId) {
      // Only return the name field, trim any whitespace
      if (discrepancyId.name) {
        return String(discrepancyId.name).trim();
      }
      return 'N/A';
    }
    // Handle ID string
    const discrepancy = discrepancies.find(d => d._id === discrepancyId);
    if (discrepancy?.name) {
      return String(discrepancy.name).trim();
    }
    return 'N/A';
  };

  const getLeadId = (project) => {
    if (!project) return '';
    if (typeof project.leadId === 'object' && project.leadId?._id) return project.leadId._id;
    if (typeof project.leadId === 'string') return project.leadId;
    // fallback if backend used a different prop name
    return project.lead?._id || project.lead || '';
  };

  const getUserName = (userRef) => {
    if (!userRef) return 'N/A';

    // If full object provided
    if (typeof userRef === 'object') {
      if (typeof userRef.name === 'string' && userRef.name.trim()) {
        return userRef.name.trim();
      }
      const first = typeof userRef.firstName === 'string' ? userRef.firstName.trim() : '';
      const last = typeof userRef.lastName === 'string' ? userRef.lastName.trim() : '';
      const combined = `${first} ${last}`.trim();
      if (combined) return combined;
      // Try lookup by _id if present
      if (userRef._id) {
        const found = users.find(u => u._id === userRef._id);
        if (found) {
          const f = typeof found.firstName === 'string' ? found.firstName.trim() : '';
          const l = typeof found.lastName === 'string' ? found.lastName.trim() : '';
          const name = typeof found.name === 'string' ? found.name.trim() : '';
          return (name || `${f} ${l}`.trim()) || 'N/A';
        }
      }
      return 'N/A';
    }

    // If string id provided
    const found = users.find(u => u._id === userRef);
    if (!found) return 'N/A';
    const f = typeof found.firstName === 'string' ? found.firstName.trim() : '';
    const l = typeof found.lastName === 'string' ? found.lastName.trim() : '';
    const name = typeof found.name === 'string' ? found.name.trim() : '';
    return (name || `${f} ${l}`.trim()) || 'N/A';
  };

  const getAssignedSummary = (project) => {
    // Show flagTo instead of design hierarchy
    if (project.flagTo) {
      return getUserName(project.flagTo);
    }
    return 'N/A';
  };

  const renderAttachments = (attachments, label) => {
    if (!attachments || !Array.isArray(attachments) || attachments.length === 0) {
      return null;
    }  
    const handleDownload = (url, name) => {
      const link = document.createElement('a');
      link.href = url;
      link.download = name || 'attachment';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };  
    return (
      <div className={classes.infoRow}>
        <span className={classes.infoLabel}>{label}:</span>
        <span className={classes.infoValue}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {attachments.map((attachment, idx) => {
              const url =
                typeof attachment === 'string'
                  ? attachment
                  : attachment.fileUrl || attachment.url || attachment.path;
  
              const name =
                attachment.fileName ||
                attachment.name ||
                attachment.filename ||
                `Attachment ${idx + 1}`;
  
              return (
                <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Tooltip title={`Download ${name}`}>
                    <IconButton
                      size="small"
                      onClick={() => handleDownload(url, name)}
                      style={{ padding: '4px' }}
                    >
                      <GetApp fontSize="small" style={{ color: '#1976d2' }} />
                    </IconButton>
                  </Tooltip>
                </div>
              );
            })}
          </div>
        </span>
      </div>
    );
  };  

  const downloadRecentFlagsCsv = () => {
    const rows = dashboardData.recentFlags || [];
    if (!rows.length) {
      setSnackInfo('No data to download', 'warning');
      return;
    }

    const headers = [
      'Sr No',
      'Lead No',
      'Discrepancy',
      'Description',
      'Assigned To',
      'Status',
      'Raised By',
      'Resolved By',
      'Created Date'
    ];

    const csvLines = [headers.join(',')];
    rows.forEach((project, idx) => {
      const leadNo = project?.leadId?.lead_no || project?.leadNo || '';
      let discrepancy = getDiscrepancyName(project?.discrepancyId);
      // Clean discrepancy name - show only the part after "+" (remove "A+" prefix)
      // if (discrepancy && discrepancy.includes('+')) {
      //   discrepancy = discrepancy.split('+').slice(1).join('+').trim();
      // }
      discrepancy = discrepancy || '';
      const description = (project?.description || '').toString().replace(/\n|\r/g, ' ').replace(/"/g, '""');
      const assigned = getAssignedSummary(project) || '';
      const status = project?.status || '';
      const raised = getUserName(project?.raisedBy) || '';
      const resolved = project?.resolvedBy ? getUserName(project.resolvedBy) : '';
      const created = project?.createdAt ? moment(project.createdAt).format('YYYY-MM-DD HH:mm') : '';

      const row = [
        idx + 1,
        `"${leadNo}"`,
        `"${discrepancy}"`,
        `"${description}"`,
        `"${assigned}"`,
        `"${status}"`,
        `"${raised}"`,
        `"${resolved}"`,
        `"${created}"`
      ].join(',');
      csvLines.push(row);
    });

    const blob = new Blob([csvLines.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `recent_flagged_projects_${moment().format('YYYYMMDD_HHmmss')}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleFilterChange = (filterName, value) => {
    setFilters(prev => ({
      ...prev,
      [filterName]: value
    }));
  };

  const handleApplyFilters = () => {
    if (userDetails._id) {
      fetchDashboard();
    }
  };

  const clearFilters = () => {
    const emptyFilters = {
      discrepancyId: '',
      experienceCenterId: '',
      raisedBy: '',
      status: '',
      startDate: '',
      endDate: ''
    };
    // Reset filters state
    setFilters(emptyFilters);
    // Immediately fetch dashboard with empty filters (no filters applied)
    // This will reset the view to show all data based on user's permissions
    if (userDetails._id) {
      fetchDashboard(emptyFilters);
    }
  };

  const renderDashboard = () => {
    return (
      <div>
        {/* Filters */}
        <Paper elevation={2} style={{ marginBottom: '24px', padding: '16px' }}>
          <Typography variant="h6" style={{ marginBottom: '16px' }}>
            Filters
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  value={filters.status}
                  onChange={(e) => handleFilterChange('status', e.target.value)}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="Open">Open</MenuItem>
                  <MenuItem value="Resolved">Resolved</MenuItem>
                  <MenuItem value="Closed">Closed</MenuItem>
                  <MenuItem value="Rejected">Rejected</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Discrepancy</InputLabel>
                <Select
                  value={filters.discrepancyId}
                  onChange={(e) => handleFilterChange('discrepancyId', e.target.value)}
                >
                  <MenuItem value="">All</MenuItem>
                  {discrepancies.map((disc) => (
                    <MenuItem key={disc._id} value={disc._id}>
                      {disc.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Experience Center</InputLabel>
                <Select
                  value={filters.experienceCenterId}
                  onChange={(e) => handleFilterChange('experienceCenterId', e.target.value)}
                >
                  <MenuItem value="">All</MenuItem>
                  {experienceCenters.map((ec) => (
                    <MenuItem key={ec._id} value={ec._id}>
                      {ec.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Raised By"
                value={filters.raisedBy}
                onChange={(e) => handleFilterChange('raisedBy', e.target.value)}
                placeholder="Enter name to search..."
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Start Date"
                type="date"
                value={filters.startDate}
                onChange={(e) => handleFilterChange('startDate', e.target.value)}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="End Date"
                type="date"
                value={filters.endDate}
                onChange={(e) => handleFilterChange('endDate', e.target.value)}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
              <Button 
                variant="contained" 
                color="primary"
                onClick={handleApplyFilters}
              >
                Apply Filters
              </Button>
              <Button 
                variant="outlined" 
                onClick={clearFilters}
              >
                Clear Filters
              </Button>
              <Button 
                variant="outlined" 
                color="primary"
                onClick={downloadRecentFlagsCsv}
              >
                Download CSV
              </Button>
            </Grid>
          </Grid>
        </Paper>

        {/* Recent Flags */}
        <Paper elevation={2}>
          <TableContainer>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.headerCell}>Sr. No</TableCell>
                  <TableCell className={classes.headerCell}>Lead No</TableCell>
                  <TableCell className={classes.headerCell}>Discrepancy</TableCell>
                  <TableCell className={classes.headerCell}>Description</TableCell>
                  <TableCell className={classes.headerCell}>Assigned To</TableCell>
                  <TableCell className={classes.headerCell}>Status</TableCell>
                  <TableCell className={classes.headerCell}>Raised By</TableCell>
                  <TableCell className={classes.headerCell}>Resolved By</TableCell>
                  <TableCell className={classes.headerCell}>Created Date</TableCell>
                  <TableCell className={classes.headerCell}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {flagsLoading ? (
                  <TableRow>
                    <TableCell colSpan={11} align="center" className={classes.tableCell}>
                      Loading...
                    </TableCell>
                  </TableRow>
                ) : dashboardData.recentFlags.length > 0 ? (
                  dashboardData.recentFlags.map((project, idx) => (
                    <TableRow key={project._id}>
                      <TableCell className={classes.tableCell}>{idx + 1}</TableCell>
                      <TableCell className={classes.tableCell}>
                        {getLeadId(project) ? (
                          <Link to={`/project-logs/${getLeadId(project)}`} style={{ textDecoration: 'underline', color: '#1C375D', fontWeight: 700 }}>
                            {project.leadId?.lead_no || project.leadNo || 'N/A'}
                          </Link>
                        ) : (
                          <span style={{ textDecoration: 'underline', fontWeight: 700 }}>
                            {project.leadId?.lead_no || project.leadNo || 'N/A'}
                          </span>
                        )}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {getDiscrepancyName(project.discrepancyId)}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {project.description || 'N/A'}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {getAssignedSummary(project)}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {getStatusChip(project.status)}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {getUserName(project.raisedBy)}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {project.resolvedBy ? getUserName(project.resolvedBy) : 'N/A'}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {project.createdAt 
                          ? moment(project.createdAt).format('DD MMM YYYY')
                          : 'N/A'}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        <Tooltip title="View Details">
                          <IconButton 
                            size="small" 
                            onClick={() => handleViewDetails(project)}
                            className={classes.actionButton}
                          >
                            <Visibility fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        {canUserResolve(project) && (
                          <Tooltip title="Mark as Resolved">
                            <IconButton 
                              size="small" 
                              onClick={() => handleStatusAction(project, 'Resolved')}
                              className={classes.actionButton}
                            >
                              <CheckCircle fontSize="small" color="primary" />
                            </IconButton>
                          </Tooltip>
                        )}
                        {canUserClose(project) && (
                          <Tooltip title="Close for Approval">
                            <IconButton 
                              size="small" 
                              onClick={() => handleStatusAction(project, 'Closed')}
                              className={classes.actionButton}
                            >
                              <Cancel fontSize="small" color="secondary" />
                            </IconButton>
                          </Tooltip>
                        )}
                        {canUserReject(project) && (
                          <Tooltip title="Reject">
                            <IconButton 
                              size="small" 
                              onClick={() => handleStatusAction(project, 'Rejected')}
                              className={classes.actionButton}
                            >
                              <Block fontSize="small" color="error" />
                            </IconButton>
                          </Tooltip>
                        )}
                        {canMailSend(project) && (
                          <Tooltip title="Send the follow-up mail to close the flag.">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => handleSendfollowupmail(project)}
                              className={classes.actionButton}
                            >
                              <EmailIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={10} align="center" className={classes.tableCell}>
                      No recent flagged projects
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    );
  };

  return (
    <div className={classes.root}>
      {renderDashboard()}

      {/* View Details Dialog */}
      <Dialog 
        open={viewDialogOpen} 
        onClose={() => setViewDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Flagged Project Details</DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {selectedProject && (
            <>
              <div className={classes.infoRow}>
                <span className={classes.infoLabel}>Lead No:</span>
                <span className={classes.infoValue}>
                  {selectedProject.leadId?.lead_no || selectedProject.leadNo || 'N/A'}
                </span>
              </div>
              <div className={classes.infoRow}>
                <span className={classes.infoLabel}>Discrepancy:</span>
                <span className={classes.infoValue}>
                  {getDiscrepancyName(selectedProject.discrepancyId)}
                </span>
              </div>
              <div className={classes.infoRow}>
                <span className={classes.infoLabel}>Description:</span>
                <span className={classes.infoValue}>{selectedProject.description || 'N/A'}</span>
              </div>
              <div className={classes.infoRow}>
                <span className={classes.infoLabel}>Status:</span>
                <span className={classes.infoValue}>{getStatusChip(selectedProject.status)}</span>
              </div>
              <div className={classes.infoRow}>
                <span className={classes.infoLabel}>Raised By:</span>
                <span className={classes.infoValue}>
                  {getUserName(selectedProject.raisedBy)}
                </span>
              </div>
              {selectedProject.resolvedBy && (
                <div className={classes.infoRow}>
                  <span className={classes.infoLabel}>Resolved By:</span>
                  <span className={classes.infoValue}>
                    {getUserName(selectedProject.resolvedBy)}
                  </span>
                </div>
              )}
              <div className={classes.infoRow}>
                <span className={classes.infoLabel}>Created Date:</span>
                <span className={classes.infoValue}>
                  {selectedProject.createdAt 
                    ? moment(selectedProject.createdAt).format('DD MMM YYYY HH:mm')
                    : 'N/A'}
                </span>
              </div>
              {(selectedProject.resolutionRemarks && selectedProject.resolutionRemarks.trim()) && (
                <>
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Resolution Remarks:</span>
                    <span className={classes.infoValue}>
                      {selectedProject.resolutionRemarks}
                    </span>
                  </div>
                  {renderAttachments(selectedProject.resolutionAttachments, 'Resolution Attachments')}
                </>
              )}
              {selectedProject?.attachments.length>0  && (
                <>
                  {renderAttachments(selectedProject?.attachments, 'Created Attachment')}
                </>
              )}
              {(selectedProject.closingRemarks && selectedProject.closingRemarks.trim()) && (
                <>
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Closing Remarks:</span>
                    <span className={classes.infoValue}>
                      {selectedProject.closingRemarks}
                    </span>
                  </div>
                  {renderAttachments(selectedProject.closingAttachments, 'Closing Attachments')}
                </>
              )}
              {selectedProject.rejectedBy && (
                <div className={classes.infoRow}>
                  <span className={classes.infoLabel}>Rejected By:</span>
                  <span className={classes.infoValue}>
                    {getUserName(selectedProject.rejectedBy)}
                  </span>
                </div>
              )}
              {(selectedProject.rejectionRemarks && selectedProject.rejectionRemarks.trim()) && (
                <>
                  <div className={classes.infoRow}>
                    <span className={classes.infoLabel}>Rejection Remarks:</span>
                    <span className={classes.infoValue}>
                      {selectedProject.rejectionRemarks}
                    </span>
                  </div>
                  {renderAttachments(selectedProject.rejectionAttachments, 'Rejection Attachments')}
                </>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewDialogOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Status Update Dialog */}
      <Dialog 
        open={statusDialogOpen} 
        onClose={() => setStatusDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {statusFormData.status === 'Resolved' 
            ? 'Mark as Resolved' 
            : statusFormData.status === 'Rejected'
            ? 'Reject Flag'
            : 'Close for Approval'}
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {statusFormData.status === 'Resolved' ? (
            <>
              <TextField
                label="Resolution Remarks"
                value={statusFormData.resolutionRemarks}
                onChange={(e) => setStatusFormData(prev => ({
                  ...prev,
                  resolutionRemarks: e.target.value
                }))}
                multiline
                rows={4}
                fullWidth
                required
                placeholder="Describe how the issue was resolved..."
                style={{ marginBottom: '16px' }}
              />
              <Button
                variant="contained"
                component="label"
                fullWidth
                style={{
                  backgroundColor: "#355025",
                  color: "#FFF2EB",
                  marginBottom: '16px',
                }}
              >
                <div>
                  Upload Attachment
                  {statusFormData.attachments.length > 0 && (
                    <span> ({statusFormData.attachments.length} file{statusFormData.attachments.length > 1 ? 's' : ''})</span>
                  )}
                </div>
                <input
                  type="file"
                  hidden
                  accept=".png, .jpg, .jpeg, .webp, .pdf, .doc, .docx"
                  multiple
                  onChange={handleAttachmentChange}
                />
                <FormGroup style={{ marginLeft: "10px" }}>
                  <FormControlLabel
                    control={
                      <Checkbox checked={statusFormData.attachments.length > 0} color="primary" />
                    }
                  />
                </FormGroup>
              </Button>
              {statusFormData.attachments.length > 0 && (
                <div style={{ marginTop: '8px' }}>
                  {statusFormData.attachments.map((att, idx) => (
                    <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                      <span style={{ flex: 1, fontSize: '14px' }}>
                        {typeof att === 'object' ? att.name : `Attachment ${idx + 1}`}
                      </span>
                      <IconButton 
                        size="small" 
                        onClick={() => removeAttachment(idx)}
                        style={{ color: '#f44336' }}
                      >
                        <Cancel fontSize="small" />
                      </IconButton>
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : statusFormData.status === 'Rejected' ? (
            <>
              <TextField
                label="Rejection Remarks"
                value={statusFormData.rejectionRemarks}
                onChange={(e) => setStatusFormData(prev => ({
                  ...prev,
                  rejectionRemarks: e.target.value
                }))}
                multiline
                rows={4}
                fullWidth
                required
                placeholder="Provide reason for rejection..."
                style={{ marginBottom: '16px' }}
              />
              <Button
                variant="contained"
                component="label"
                fullWidth
                style={{
                  backgroundColor: "#355025",
                  color: "#FFF2EB",
                  marginBottom: '16px',
                }}
              >
                <div>
                  Upload Attachment
                  {statusFormData.attachments.length > 0 && (
                    <span> ({statusFormData.attachments.length} file{statusFormData.attachments.length > 1 ? 's' : ''})</span>
                  )}
                </div>
                <input
                  type="file"
                  hidden
                  accept=".png, .jpg, .jpeg, .webp, .pdf, .doc, .docx"
                  multiple
                  onChange={handleAttachmentChange}
                />
                <FormGroup style={{ marginLeft: "10px" }}>
                  <FormControlLabel
                    control={
                      <Checkbox checked={statusFormData.attachments.length > 0} color="primary" />
                    }
                  />
                </FormGroup>
              </Button>
            </>
          ) : (
            <>
              <TextField
                label="Closing Remarks"
                value={statusFormData.closingRemarks}
                onChange={(e) => setStatusFormData(prev => ({
                  ...prev,
                  closingRemarks: e.target.value
                }))}
                multiline
                rows={4}
                fullWidth
                required
                placeholder="Provide remarks for closure approval..."
                style={{ marginBottom: '16px' }}
              />
              <Button
                variant="contained"
                component="label"
                fullWidth
                style={{
                  backgroundColor: "#355025",
                  color: "#FFF2EB",
                  marginBottom: '16px',
                }}
              >
                <div>
                  Upload Attachment
                  {statusFormData.attachments.length > 0 && (
                    <span> ({statusFormData.attachments.length} file{statusFormData.attachments.length > 1 ? 's' : ''})</span>
                  )}
                </div>
                <input
                  type="file"
                  hidden
                  accept=".png, .jpg, .jpeg, .webp, .pdf, .doc, .docx"
                  multiple
                  onChange={handleAttachmentChange}
                />
                <FormGroup style={{ marginLeft: "10px" }}>
                  <FormControlLabel
                    control={
                      <Checkbox checked={statusFormData.attachments.length > 0} color="primary" />
                    }
                  />
                </FormGroup>
              </Button>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setStatusDialogOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleStatusUpdate} color="primary" variant="contained">
            {statusFormData.status === 'Resolved' 
              ? 'Mark Resolved' 
              : statusFormData.status === 'Rejected'
              ? 'Reject'
              : 'Close'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapDispatchToProps = {
  setLoading,
  setSnackInfo,
};

export default connect(null, mapDispatchToProps)(FlaggedProject);